import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { FormProvider } from 'react-hook-form';
import FormTextField from '../../formElements/textfield';

const ChatInput = ({
  formMethods,
  isPending,
  onSubmit,
  onKeyPress,
}) => {
  return (
    <Box className="chat-input">
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)} className="message-form">
          <FormTextField
            name="message"
            placeholder={isPending ? "Sending message..." : "Type your message..."}
            className="message-field"
            multiline
            maxRows={3}
            disabled={isPending}
            onKeyDown={onKeyPress}
          />
          <IconButton
            type="submit"
            disabled={isPending}
            className="send-button"
            title={isPending ? "Sending message..." : "Send message"}
          >
            <SendIcon />
          </IconButton>
        </form>
      </FormProvider>
    </Box>
  );
};

export default ChatInput;
